import * as React from "react";

export type DrawerContextProps = {
  container: React.RefObject<HTMLDivElement>;
  content: React.RefObject<HTMLDivElement>;
  body: React.RefObject<HTMLDivElement>;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

export const defaultDrawerContextProps = {
  container: { current: null },
  content: { current: null },
  body: { current: null },
  isOpen: false,
  setIsOpen: () => undefined,
};

export const DrawerContext = React.createContext<DrawerContextProps>(
  defaultDrawerContextProps,
);
